import { getRelativePath } from 'base/shared/Utils';

const BASE_PATH = '/enquiry';

export const getEnquiryPath = ({ connectionId }) =>
  connectionId ? getRelativePath(`${BASE_PATH}/${connectionId}`) : '';
